export default __webpack_public_path__ + "db50a7bf1dbd95d8c6199da95d66e431.webp";